namespace GeniuzPOS.InitialData {
    export interface PsPanelGroupButtonForm {
        GroupButtonId: Serenity.IntegerEditor;
        TouchPanelType: Serenity.LookupEditor;
        GroupButtonLabel: Serenity.StringEditor;
        TxtFontSize: Serenity.DecimalEditor;
        BgColor: Serenity.LookupEditor;
        TxtColor: Serenity.LookupEditor;
        GroupButtonImage: Serenity.ImageUploadEditor;
        DtList: PsPanelItemButtonEditor;
    }

    export class PsPanelGroupButtonForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsPanelGroupButton';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsPanelGroupButtonForm.init)  {
                PsPanelGroupButtonForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.ImageUploadEditor;
                var w5 = PsPanelItemButtonEditor;

                Q.initFormType(PsPanelGroupButtonForm, [
                    'GroupButtonId', w0,
                    'TouchPanelType', w1,
                    'GroupButtonLabel', w2,
                    'TxtFontSize', w3,
                    'BgColor', w1,
                    'TxtColor', w1,
                    'GroupButtonImage', w4,
                    'DtList', w5
                ]);
            }
        }
    }
}
